import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

const PageBody = () => {
  const locale = getLocaleFromCookie(); // Preserved for potential future use
  const { t } = useTranslation();

  const links = [
  {
    href: "/expo/feedback",
    key: "expo.feedback",
    fallback: "Deja un mensaje en el libro de visitas",
    className: "btn btn-black w-100 mt-2",
  },
  {
    href: "/officina",
    key: "expo.shop",
    fallback: "Compra las imágenes",
    className: "btn btn-black w-100 mt-2",
  },
  {
    href: "https://cal.com/lussana/that-s-life-a-wonderful-adventure",
    key: "expo.visita",
    fallback: "Reserva una visita privada",
    className: "btn btn-outline-black w-100 mt-2",
  },
  {
    href: "/about-me",
    key: "expo.aboutMe",
    fallback: "Conoce más sobre mí",
    className: "btn btn-outline-black w-100 mt-2",
  },
  {
    href: "/contacts",
    key: "expo.contacts",
    fallback: "Contáctame",
    className: "btn btn-outline-black w-100 mt-2",
  },
];

  return (
    <div className="container mt-5 mt-xl-10">
      <div className="row mb-5 g-3 g-xl-5 align-items-end">
        <div className="col-lg-12">
          {links.map((link, index) => (
            <a
              key={link.key}
              href={link.href}
              target="_blank"
              rel="noreferrer"
              className={link.className}
	  		  style={{ textTransform: "uppercase" }}
            >
              {t(link.key, link.fallback)}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PageBody;
